import React, {useEffect, useState} from 'react'
import PriorAuthorizationContext, {PriorAuthorizationDefault} from "./PriorAuthorization.context";

import mixinMethods from "./mixins";
import ConfirmationModal from "../../components/Common/ConfirmationModal";

export default function PriorAuthorizationProvider({children, context = PriorAuthorizationDefault}) {

    const [state, setState] = useState(context)
    const { commonMethods, createMethods, inquiryMethods } = mixinMethods([state, setState])

    const value = {
        ...state,
        setState,
        ...commonMethods(),
        create: {
            ...state.create,
            ...createMethods()
        },
        inquiry: {
            ...state.inquiry,
            ...inquiryMethods()
        }
    };

    useEffect(value.create.setFinalStepStatus, [state.create.currentStep])
    useEffect(value.create.validateAllSteps, [state.fields])
    useEffect( () => {
        if(state.cb){
            state.cb(value)
        }
    // eslint-disable-next-line
    }, [state.cb])

    return (
        <PriorAuthorizationContext.Provider value={value}>
            {children}
            <ConfirmationModal {...state.modalState}/>
        </PriorAuthorizationContext.Provider>
    )
}